var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-ignore
import pbkdf2 from "pbkdf2";
import React, { Component } from "react";
// @ts-expect-error
import { connect } from "../../../../../connection";
import { toJid } from "../../../base/connection/functions";
import { translate, translateToHTML } from "../../../base/i18n/functions";
import { JitsiConnectionErrors } from "../../../base/lib-jitsi-meet";
import { connect as reduxConnect } from "../../../base/redux/functions";
import Dialog from "../../../base/ui/components/web/Dialog";
import Input from "../../../base/ui/components/web/Input";
import { authenticateAndUpgradeRole, hideLoginDialog } from "../../actions.web";
import { elpLoginFailed, elpLoginSuccess, setMyInfoAPI, setRoomIdAPI } from "../../../base/conference/actions";
/**
 * Component that renders the login in conference dialog.
 *
 *  @returns {React$Element<any>}
 */
class LoginDialog extends Component {
    /**
     * Initializes a new {@code LoginDialog} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            loginStarted: false,
            isMount: false,
        };
        this._onCancelLogin = this._onCancelLogin.bind(this);
        this._onLogin = this._onLogin.bind(this);
        this._onUsernameChange = this._onUsernameChange.bind(this);
        this._onPasswordChange = this._onPasswordChange.bind(this);
    }
    /**
     * Called when the cancel button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onCancelLogin() {
        const { dispatch } = this.props;
        dispatch(hideLoginDialog());
    }
    /**
     * Notifies this LoginDialog that the login button (OK) has been pressed by
     * the user.
     *
     * @private
     * @returns {void}
     */
    _onLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            const { _conference: conference, _configHosts: configHosts, roomName, onSuccess, dispatch, _isLogin: isLogin } = this.props;
            const { password, username } = this.state;
            const jid = toJid(username, configHosts !== null && configHosts !== void 0 ? configHosts : {
                authdomain: "",
                domain: "",
            });
            // @ts-ignore
            const hashedPassWord = pbkdf2
                .pbkdf2Sync(password, username, 9999, 32, "sha512")
                .toString("base64");
            if (conference) {
                const formdata = new FormData();
                formdata.append("username", username);
                formdata.append("password", hashedPassWord);
                fetch("/livi/login", {
                    method: "POST",
                    headers: { 'Login-Type': 'api' },
                    body: formdata
                }).then(res => {
                    if (res.status === 200) {
                        console.log("ELP login success");
                        dispatch(elpLoginSuccess());
                        dispatch(setRoomIdAPI());
                        dispatch(setMyInfoAPI());
                    }
                    else {
                        console.log("ELP login failed");
                        dispatch(elpLoginFailed());
                    }
                });
                dispatch(authenticateAndUpgradeRole(jid, hashedPassWord, conference));
            }
            else {
                this.setState({
                    loginStarted: true,
                });
                connect(jid, hashedPassWord, roomName)
                    .then((connection) => {
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(connection);
                })
                    .catch(() => {
                    this.setState({
                        loginStarted: false,
                    });
                });
            }
        });
    }
    /**
     * Callback for the onChange event of the field.
     *
     * @param {string} value - The static event.
     * @returns {void}
     */
    _onPasswordChange(value) {
        this.setState({
            password: value,
        });
    }
    /**
     * Callback for the onChange event of the username input.
     *
     * @param {string} value - The new value.
     * @returns {void}
     */
    _onUsernameChange(value) {
        this.setState({
            username: value,
        });
    }
    /**
     * Renders an optional message, if applicable.
     *
     * @returns {ReactElement}
     * @private
     */
    renderMessage() {
        const { _configHosts: configHosts, _connecting: connecting, _error: error, _progress: progress, t, } = this.props;
        const { username, password } = this.state;
        const messageOptions = {};
        let messageKey;
        if (progress && progress < 1) {
            if (error) {
                messageKey = `${error.message}`.replace(/:/gi, " ");
            }
            else if (progress === 0.5) { // 선생님이 로그인할 경우 버튼 지연 시간 동안 연결 중 표시 처리
                messageKey = t("prejoin.connecting");
            }
            else {
                console.log(progress);
                messageKey = t("connecting.FETCH_SESSION_ID");
            }
        }
        else if (error) {
            const { name } = error;
            if (name === JitsiConnectionErrors.PASSWORD_REQUIRED) {
                const { credentials } = error;
                if (credentials &&
                    credentials.jid ===
                        toJid(username, configHosts !== null && configHosts !== void 0 ? configHosts : { authdomain: "", domain: "" })) {
                    messageKey = t("dialog.incorrectPassword");
                }
            }
            else if (name) {
                messageKey = t("dialog.connectErrorWithMsg");
                messageOptions.msg = `${name} ${error.message}`;
            }
        }
        else if (connecting) {
            messageKey = t("connection.CONNECTING");
        }
        if (messageKey) {
            return (React.createElement("span", null, translateToHTML(t, messageKey, messageOptions)));
        }
        return null;
    }
    componentDidMount() {
        try {
            const { _conference: conference, _progress: progress, _configHosts: configHosts, roomName, onSuccess, dispatch } = this.props;
            const username = window.sessionStorage.getItem("username");
            const passcode = window.sessionStorage.getItem("passcode");
            // @ts-ignore
            const jid = toJid(username, configHosts);
            // console.log("--------------------------");
            // console.log(passcode);
            // console.log(username);
            //
            // console.log('--------------------------- progress');
            // console.log(progress);
            if (conference) {
                // @ts-ignore
                dispatch(authenticateAndUpgradeRole(jid, passcode, conference)).then(() => {
                    // console.log('--------------------------- progress');
                    // console.log(progress);
                    this.setState({ isMount: true });
                });
            }
            else {
                this.setState({
                    loginStarted: true,
                });
                connect(jid, passcode, roomName)
                    .then((connection) => {
                    onSuccess && onSuccess(connection);
                    console.log("-------------------성공");
                })
                    .catch(() => {
                    this.setState({
                        loginStarted: false,
                    });
                    console.log("---------------------실패");
                });
            }
        }
        catch (e) {
            console.log("------자동로그인 실패");
        }
    }
    /**
     * Implements {@Component#render}.
     *
     * @inheritdoc
     */
    render() {
        const { _connecting: connecting, _progress: progress, t } = this.props;
        const { password, loginStarted, username, isMount } = this.state;
        return (React.createElement(Dialog, { disableBackdropClose: true, hideCloseButton: true, ok: {
                disabled: connecting || loginStarted || !password || !username || progress != null,
                translationKey: "dialog.login",
            }, onCancel: this._onCancelLogin, onSubmit: this._onLogin, titleKey: (connecting) ? t("dialog.loggingIn") : t("dialog.authenticationRequired") },
            React.createElement(Input, { autoFocus: true, label: t("dialog.user"), name: "username", onChange: this._onUsernameChange, placeholder: t("dialog.userIdentifier"), type: "text", value: username }),
            React.createElement("br", null),
            React.createElement(Input, { className: "dialog-bottom-margin", label: t("dialog.userPassword"), name: "password", onChange: this._onPasswordChange, placeholder: t("dialog.password"), type: "password", value: password }),
            this.renderMessage()));
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code LoginDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function mapStateToProps(state) {
    const { error: authenticateAndUpgradeRoleError, progress, thenableWithCancel, } = state["features/authentication"];
    const { authRequired, conference, isLogin, onlineClassID, serviceForVisionLoss, roomInfoID } = state["features/base/conference"];
    const { hosts: configHosts } = state["features/base/config"];
    const { connecting, error: connectionError } = state["features/base/connection"];
    return {
        _conference: authRequired || conference,
        _configHosts: configHosts,
        _connecting: connecting || thenableWithCancel,
        _error: connectionError || authenticateAndUpgradeRoleError,
        _progress: progress,
        _isLogin: isLogin,
    };
}
export default translate(reduxConnect(mapStateToProps)(LoginDialog));
